// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".generalImage--K2aan9UV .ant-image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n.extraContainer--f_f21B2i {\n  margin-top: 15px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generalImage": "generalImage--K2aan9UV",
	"extraContainer": "extraContainer--f_f21B2i"
};
export default ___CSS_LOADER_EXPORT___;
